import classNames from 'classnames';
import React from 'react';
import { SizeTypes } from '../../constants';
import './size.scss';

interface SizeProps {
  size?: string;
  selected?: boolean;
  onClick?: (event: React.SyntheticEvent<any>) => void;
}

const defaultProps: SizeProps = {
  size: SizeTypes[0].label,
  selected: false
};

const Size: React.SFC<SizeProps> = props => (
  <div
    onClick={props.onClick}
    className={classNames('c-man c-man--' + props.size, {
      'is-selected': props.selected
    })}
  />
);

Size.defaultProps = defaultProps;

export default Size;



// WEBPACK FOOTER //
// ./src/components/size/size.tsx